import styled from "styled-components";
import { Input } from "antd";

export const InputWrapper = styled(Input)`
  outline: none;
  height: 40px !important;
  border-radius: 4px;
  width: 100%;
  font-weight: 500;
  transition: 0.3s ease;

  ::placeholder {
    color: #d0d0d0;
    font-weight: 500;
    user-select: none;
  }
  input {
    border-radius: 4px;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    ::placeholder {
      color: #d0d0d0;
      font-weight: 500;
      user-select: none;
    }
    &:focus {
      border: none !important;
      outline: none !important;
      box-shadow: none !important;
    }
  }
  &:hover {
    transition: 0.3s ease;
    border: 1px solid #49d3ce;
    box-shadow: none !important;
  }
  &:active {
    transition: 0.3s ease;
    border: 1px solid #49d3ce;
    box-shadow: none !important;
  }
  &:focus {
    transition: 0.3s ease;
    border: 1px solid #49d3ce;
    box-shadow: none !important;
  }
`;
